var _path, _path2, _circle, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnResourceCenterLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 17.795C29.0589 17.7861 29.9449 17.7861 31 17.7861V31.4661C26.68 31.4661 24.52 31.4661 22 32.9061C19.48 31.4661 18.76 31.4661 13 31.4661V17.7861C14.0551 17.7861 14.9411 17.7861 15.7 17.795",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L22 32",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18.7437,
    r: 6.9,
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.55 11.9941C21.55 11.9941 18.85 14.8665 18.85 18.7441C18.85 22.6218 21.55 25.4941 21.55 25.4941",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 11.9941C22.45 11.9941 25.15 14.8665 25.15 18.7441C25.15 22.6218 22.45 25.4941 22.45 25.4941",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9619 18.5493C14.9619 18.5493 18.0219 19.4639 22.1529 19.4639C26.2839 19.4639 29.0379 18.5493 29.0379 18.5493",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnResourceCenterLight);
export default __webpack_public_path__ + "static/media/btn_resource_center_light.03a98df0d849cb11c1c19026b0c26675.svg";
export { ForwardRef as ReactComponent };